<template>
  <div id="zeitraum-modal" class="modal fade">
    <div class="modal-dialog">
      <div class="modal-content">
        <ValidationObserver v-slot="{ invalid }" :disabled="true">
          <div class="modal-header">
            <modal-close-button @confirmed="closeModal" />
            <h4 class="modal-title">{{ $t("global.period") }}</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    immediate
                    v-slot="{ passed }"
                  >
                    <label :class="{ 'text-danger': !passed }">{{
                      $t("global.From")
                    }}</label>
                    <input
                      ref="vonInput"
                      v-model="zeitraum.von"
                      :class="{ 'border-danger': !passed }"
                      type="date"
                      class="form-control"
                      :min="datetimeToDate(minDatum)"
                      :max="
                        datetimeToDate(zeitraum.bis) || datetimeToDate(maxDatum)
                      "
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    immediate
                    v-slot="{ passed }"
                  >
                    <label :class="{ 'text-danger': !passed }">{{
                      $t("global.till")
                    }}</label>
                    <input
                      ref="bisInput"
                      v-model="zeitraum.bis"
                      :class="{ 'border-danger': !passed }"
                      type="date"
                      class="form-control"
                      :min="
                        datetimeToDate(zeitraum.von) || datetimeToDate(minDatum)
                      "
                      :max="datetimeToDate(maxDatum)"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <!-- <div class="col-xl-6">
                <div class="form-group">
                  <date-picker
                    date-format="dd.mm.yy"
                    :initial="zeitraum.von"
                    placeholder=" "
                    :show-icon="true"
                    @update="(val) => (zeitraum.von = val)"
                  />
                  <label>Von</label>
                </div>
              </div>

              <div class="col-xl-6">
                <div class="form-group">
                  <date-picker
                    date-format="dd.mm.yy"
                    :initial="zeitraum.bis"
                    placeholder=" "
                    :show-icon="true"
                    @update="(val) => (zeitraum.bis = val)"
                  />
                  <label>Bis</label>
                </div>
              </div> -->
            </div>
            <div class="row">
              <div class="col-xl-6">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    immediate
                    v-slot="{ passed }"
                  >
                    <input
                      v-model="zeitraum.einsatzplaetze"
                      type="number"
                      class="form-control"
                      :placeholder="$t('global.numberofyouths')"
                      :class="{ 'border-danger': !passed }"
                    />
                    <label :class="{ 'text-danger': !passed }">{{
                      $t("global.numberofyouths")
                    }}</label>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    immediate
                    v-slot="{ passed }"
                  >
                    <v-select
                      v-model="zeitraum.belegungsstatus"
                      class="mb-3"
                      v-bind:class="{ 'border-danger': !passed }"
                      :getOptionLabel="(feld) => feld.bezeichnung"
                      :options="belegungsstati"
                      :placeholder="$t('global.occupancystatus')"
                    >
                      <span slot="no-options">{{
                        $t("global.taptosearch")
                      }}</span>
                    </v-select>
                    <label v-bind:class="{ 'text-danger': !passed }">{{
                      $t("global.occupancystatus")
                    }}</label>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- <div class="col-xl-12">
                <div class="form-group">
                  <textarea
                    v-model="zeitraum.beschreibung"
                    class="form-control"
                    rows="2"
                    style="resize: vertical"
                  ></textarea>
                  <label>{{ $t("global.description") }}</label>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <ValidationProvider
                    :rules="{ min_value: 0, max_value: 10 }"
                    immediate
                    v-slot="{ errors }"
                  >
                    <input
                      v-model="zeitraum.belastungsgrad"
                      type="number"
                      class="form-control"
                      :placeholder="$t('global.degreeofload')"
                      min="0"
                      max="10"
                      :class="{ 'border-danger': errors.length }"
                    />
                    <span
                      class="minusIcon"
                      v-tooltip="'Platzhalter Beschreibung'"
                    >
                      <font-awesome-icon icon="fa-solid fa-circle-info" />
                    </span>
                    <label :class="{ 'text-danger': errors.length }"
                      >Körperliche Belastung (von 1-10)</label
                    >
                  </ValidationProvider>
                </div>
              </div> -->
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="closeModal">
              {{ $t("global.cancel") }}
            </button>
            <button
              type="button"
              :disabled="invalid"
              class="btn btn-success"
              @click="uebernehmen"
              :title="invalid ? $t('global.notallfieldsfilledcorrectly') : ''"
            >
              {{ $t("global.save") }}
            </button>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { modal } from "@/mixins/Modal";
import ModalCloseButton from "@/components/global/ModalCloseButton";

import DatePicker from "@/components/Datepicker";

import { apiErrorToAlert } from "@/utils/Errorhandler";
import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";

import AppApi from "@/api/AppApi";

export default {
  name: "ZeitraumModal",
  components: {
    ModalCloseButton,
  },
  mixins: [modal],

  props: {
    id: {
      type: String,
      required: false,
    },
    zeitraumProp: {
      type: Object,
      required: false,
    },
    minDatum: {
      type: String,
      required: true,
    },
    maxDatum: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      shown: false,
      zeitraum: {
        id: null,
        angebot: this.id,
        von: null,
        bis: null,
        einsatzplaetze: null,
        belegungsstatus: null,
      },
    };
  },
  computed: {
    belegungsstati() {
      if (this.$store) return this.$store.state.crm.belegungsstati;
      return [];
    },
  },
  watch: {},
  created() {},
  mounted() {
    this.$bus.$on("open-zeitraum-modal", () => {
      if (!this.shown) this.openModal();
    });

    if (this.belegungsstati?.length == 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);
  },
  methods: {
    openModal() {
      this.shown = true;

      $("#zeitraum-modal").modal({
        backdrop: "static",
        keyboard: false,
      });

      this.zeitraum = JSON.parse(JSON.stringify(this.zeitraumProp));

      if (!this.zeitraum.belegungsstatus) {
        const status = this.belegungsstati.find((s) => s.id === "196F80D0417");
        this.zeitraum.belegungsstatus = status;
      }

      this.zeitraum.von = this.germanToIso(this.zeitraum.von);
      this.zeitraum.bis = this.germanToIso(this.zeitraum.bis);
    },
    closeModal() {
      this.shown = false;
      $("#zeitraum-modal").modal("hide");
    },
    uebernehmen() {
      if (this.loading) return;
      if (!this.checkHTMLValidity()) return;

      this.loading = true;

      let json = JSON.parse(JSON.stringify(this.zeitraum));

      json.von = this.isoToGerman(json.von);
      json.bis = this.isoToGerman(json.bis);

      if (!json.id) {
        AppApi.post("zeitraum/", json, {
          params: {
            angebotId: this.id,
          },
        })
          .then((response) => {
            this.$notify({
              type: "success",
              title: this.$t("global.actionsuccessful"),
              text: this.$t("global.successfullysaved"),
            });
            this.closeModal();
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
          })
          .finally(() => {
            this.loading = false;
            this.$bus.$emit("reload-zeitraeume");
          });
      } else {
        AppApi.put("zeitraum/", json)
          .then((response) => {
            this.$notify({
              type: "success",
              title: this.$t("global.actionsuccessful"),
              text: this.$t("global.successfullysaved"),
            });
            this.closeModal();
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
          })
          .finally(() => {
            this.loading = false;
            this.$bus.$emit("reload-zeitraeume");
          });
      }
    },

    isoToGerman(dateString) {
      if (!dateString) {
        return null;
      }
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${day}.${month}.${year} ${hours}:${minutes}:00`;
    },

    germanToIso(dateTimeString) {
      if (!dateTimeString) {
        return null;
      }
      const [day, month, year] = dateTimeString.split(".");

      return `${year}-${month}-${day}`;
    },

    datetimeToDate(datetime) {
      if (!datetime) return null;
      return datetime.split("T")[0];
    },

    checkHTMLValidity() {
      const vonInput = this.$refs.vonInput;
      const bisInput = this.$refs.bisInput;
      if (!vonInput.checkValidity()) {
        vonInput.reportValidity();
        return false;
      }
      if (!bisInput.checkValidity()) {
        bisInput.reportValidity();
        return false;
      }
      return true;
    },
  },
};
</script>
